import React from 'react'
import { View, StyleSheet } from 'react-native'
import { FORM, COLUMN_SPACER, ROW_SPACER } from '@adalo/constants'

const getSkeletonStyles = component => {
  const { layout, attributes } = component
  const { height } = attributes

  return {
    ...layout,
    height,
    backgroundColor: '#E0E0E0',
    opacity: 0.5,
    position: 'static',
  }
}

const FieldSkeleton = () => {
  const style = {
    backgroundColor: 'white',
    height: 40,
    width: '90%',
  }

  return <View style={style} />
}

const FormSkeleton = ({ component }) => {
  const { attributes } = component
  const { fields } = attributes

  const style = {
    ...getSkeletonStyles(component),
    justifyContent: 'space-evenly',
    alignItems: 'center',
  }

  return (
    <View style={style}>
      {fields.map(({ fieldId }) => (
        <FieldSkeleton key={fieldId} />
      ))}
    </View>
  )
}

const SpacerSkeleton = ({ component }) => {
  const style = {
    ...getSkeletonStyles(component),
    opacity: 0,
  }

  return <View style={style} />
}

const DefaultSkeleton = ({ component }) => {
  const style = getSkeletonStyles(component)

  return <View style={style} />
}

const skeletonComponents = component => {
  const { type, id } = component

  switch (type) {
    case COLUMN_SPACER:
    case ROW_SPACER:
      return <SpacerSkeleton key={id} component={component} />
    case FORM:
      return <FormSkeleton key={id} component={component} />
    default:
      return <DefaultSkeleton key={id} component={component} />
  }
}

const Skeleton = ({ object, fixed }) => {
  let backgroundColor

  if (fixed) {
    backgroundColor = 'transparent'
  }

  return (
    <View style={[styles.wrapper, { backgroundColor }]}>
      {object.children.map(skeletonComponents)}
    </View>
  )
}

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
  },
})

export default Skeleton
